// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"69924824","388":"96752124","473":"a39da63f","496":"52ab6ad8","501":"0da5ad4d","506":"947117e8","724":"6a6cb1bf","821":"39595343","950":"46f2ad14"}[chunkId] + ".css";
};